export const NAV_ITEMS = [
  { label: "Biog", path: "/biog" },
  { label: "Recordings", path: "/recordings" },
  { label: "Calendar", path: "/calendar" },
  { label: "Projects", path: "/projects" },
  { label: "Press", path: "/press" },
  { label: "Teaching", path: "/teaching" },
];
